<template>
  <button
      v-if="coachBill.coachingType === 'private_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printPrivateCoaching">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{$t('general.print')}}
  </button>
  <button
      v-if="
        coachBill.coachingType === 'group_coaching' &&
        coachBill.billingType === 'pauschalbetrag'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printGroupCoachingPauschal">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{$t('general.print')}}
  </button>
  <button
      v-else-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType !== 'pauschalbetrag'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printGroupCoachingHourly">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{$t('general.print')}}
  </button>
  <button
      v-if="coachBill.coachingType === 'assisted_living_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printAssistedLivingCoaching">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{$t('general.print')}}
  </button>
  <button
      v-if="coachBill.coachingType === 'case_management_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printCaseManagementCoaching">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{$t('general.print')}}
  </button>
</template>

<script setup>
import { downloadFile } from '@/shared/functions';
import { defineProps } from 'vue';

const props = defineProps({
  coachBill: {
    type: Object,
    required: true,
  },
  icon: {
    type: Boolean,
    default: false,
  },
});

const printPrivateCoaching = () => {
  downloadFile(
      `/coach-billing/private-coaching/print-bill/${props.coachBill.id}`,
      undefined, undefined
  );
};

const printGroupCoachingHourly = () => {
  downloadFile(
      `/coach-billing/group-coaching/hourly-wages-bill-print/${props.coachBill.id}`,
      undefined,
  );
};

const printGroupCoachingPauschal = () => {
  downloadFile(
      `/coach-billing/group-coaching/pauschal-print/${props.coachBill.id}`,
      undefined,
  );
};

const printAssistedLivingCoaching = () => {
  downloadFile(
      `/coach-billing/assisted-living-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};

const printCaseManagementCoaching = () => {
  downloadFile(
      `/coach-billing/case-management-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};
</script>

<style scoped>
.btn-padded {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
